import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_public/organizations/$slug")({
  staticData: { title: "Organization" },
  component: () => <Outlet />,
});
